module.exports = {"title":"Социальные сети с хэштегом #Stop_E40"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/social-feeds.ru.json
// module id = 183
// module chunks = 0